"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InverseDepth = void 0;
const utils_1 = require("../../utils");
const dataSource_1 = require("../dataSource");
class InverseDepth extends dataSource_1.Depth {
    async getDepthData(instrumentAddr, expiry, stepRatio, length = 10, overrides) {
        const isInverse = await this.dataSource.ctx.perp.configuration.isInverse(instrumentAddr);
        const results = await super.getDepthData(instrumentAddr, expiry, stepRatio, length, overrides);
        return isInverse
            ? {
                left: results.right.map((d) => {
                    return {
                        ...d,
                        price: (0, utils_1.reversePrice)(d.price),
                    };
                }),
                right: results.left.map((d) => {
                    return {
                        ...d,
                        price: (0, utils_1.reversePrice)(d.price),
                    };
                }),
            }
            : results;
    }
}
exports.InverseDepth = InverseDepth;
